<script setup>
  import axios from 'axios';
  import AxiosHelper from '../../utils/axios_helper'; //CSRF
  
  import { addIcon, xIcon } from '../..//utils/icons'

  import { ref, watch } from 'vue';

  const action = document.getElementById("action").value;

  const filtro = ref({})
  
  if(action == "new") {
    
    filtro.value = {
      nombre: "",
      tipo: "texto",
      integer_values: { min: null, max: null, salto: null},
      select_values: [],
    };

  }else if (action == "edit") {

    filtro.value = JSON.parse(document.getElementById("filtro").value);

    // Para que no de error si cambio el tipo, debo poblar lo siguiente ...
    if (filtro.value.integer_values == null) {
      filtro.value.integer_values = { min: null, max: null, salto: null};
    }

    if (filtro.value.select_values == null) {
      filtro.value.select_values = []
    }
  }


  const filtro_changed = ref(false);

  const tipos =[ 
    {"value": "texto", "text": "Texto"},
    {"value": "numero", "text": "Número"},
    {"value": "selector", "text": "Selector"},
  ];

  // Watcher para los cambios en test
  const unwatch = watch(filtro, () => { 
      filtro_changed.value = true;
    },  {deep:true}
  )

  function add_select_value() {
    filtro.value.select_values.push("");
  }

  function remove_select_value(index) {
    filtro.value.select_values.splice(index, 1);
  }

  function save_filtro() {
    if (!filtro_changed.value) return;
    filtro.value.id ? update_filtro() : create_filtro();
  }

  function validate() {
    if (filtro.value.tipo != 'numero' && filtro.value.tipo != 'selector'){
      return true;
    
    }else if (filtro.value.tipo == 'numero') {
      return (filtro.value.integer_values != null && filtro.value.integer_values.min != null && filtro.value.integer_values.max != null && filtro.value.integer_values.salto != null);
    
    }else if (filtro.value.tipo == 'selector') {
      return (filtro.value.select_values != null && filtro.value.select_values.length > 0)
    }
  }

  async function create_filtro() {
    //CSRF
    AxiosHelper();
     
    const filtro_json = JSON.parse(JSON.stringify(filtro.value));
    try {
      const response = await axios.post("/filtros.json", { filtro: filtro_json});
      //Ponemos el id, que es el dato nuevo.
      if(response.statusText == "Created") {
        window.location.href = '/filtros';
      }
      
    } catch (error){ 
      console.log(error);
    }
  }

  async function update_filtro() {
    //CSRF
    AxiosHelper();
    
    const filtro_json = JSON.parse(JSON.stringify(filtro.value));
    try {
      const response = await axios.put("/filtros/"+filtro_json.id+".json", { filtro: filtro_json});
      
      if(response.statusText == "OK") {
        window.location.href = '/filtros';
      }
      
    } catch (error){ 
      console.log(error);
    }
  }

</script>

<template>

<div class="w-full my-8">

  <div class="flex justify-between items-center">
    <h1 class="font-bold text-4xl">{{ filtro.id == null ? "Nuevo filtro" : "Editar filtro"}}</h1>
    <a href="/filtros" class="button">Listado</a>
  </div>

  <div class="flex space-x-4">
    <div class="my-3 w-1/2">
      <h5 class="label-f">Tipo</h5>
      <select v-model="filtro.tipo" class="select-f">
        <option v-for="tipo in tipos" :value="tipo.value" :key="tipo.value">{{ tipo.text }}</option>
      </select>
    </div>
    <div class="my-3 w-1/2">
      <h5 class="label-f">Nombre</h5>
      <input v-model="filtro.nombre" type="text" placeholder="Nombre" class="input-f">
    </div>
  </div>

  <div v-if="filtro.tipo == 'texto'">

    <div class="explain border rounded p-3 my-4 bg-blue-100 text-sm">
      Los filtros de <b>texto</b> permiten añadir a los test campos como <b>Nombre</b>, <b>Apellidos</b>, etc.
      <br>Será un campo de texto adicional que quien realice el test deberá rellenar.
    </div>
  
  </div>

  <div v-if="filtro.tipo == 'numero'">
  
    <div class="explain border rounded p-3 my-4 bg-blue-100 text-sm">
      Los filtros <b>numéricos</b> permiten introducir un número, dentro de un rango, entre un <b>mínimo</b> y un <b>máximo</b> con un paso indicado por <b>salto</b>.
      <br>Por ejemplo, si queremos que el usuario itroduzca su <b>edad</b> podemos crear un filtro con los siguientes datos: min=18, max=99 y salto=1.
      <br>De esta forma, en los test, podremos añadir filtro desplegable con números del 18 al 99 saltando de 1 en 1.
    </div>
  
    <div class="flex space-x-4">
      <div class="my-5">
        <h5 class="label-f">Mínimo</h5>
        <input v-model="filtro.integer_values.min" type="text" placeholder="Mín" class="input-f">
      </div>
      <div class="my-5">
        <h5 class="label-f">Máximo</h5>
        <input v-model="filtro.integer_values.max" type="text" placeholder="Max" class="input-f">
      </div>
      <div class="my-5">
        <h5 class="label-f">Salto</h5>
        <input v-model="filtro.integer_values.salto" type="text" placeholder="Salto" class="input-f">
      </div>
    </div>
  
  </div>

  <div  v-if="filtro.tipo == 'selector'">

    <div class="explain border rounded p-3 my-4 bg-blue-100 text-sm">
      El filtro <b>selector</b> permite crear desplegables con <b>valores</b> preestablecidos.<br>
      Un caso de uso podría ser: nombre_del_filtro=estudios y creamos los siguientes valores: "Sin estudios", "Eso", "Bachillerto", "Formación Profesional", "Universitarios", "Post-Universitarios"
    </div>

    <div class="flex items-center mb-4 my-5">
      <h5 class="text-gray-700">Valores del selector</h5>
      <button class="button p-0 px-2 ml-10" type="button" @click="add_select_value"><i v-html='addIcon'></i></button>
      </div>
      <div class="flex flex-wrap">

        <div v-for="(value, index) in filtro.select_values" :key="index" 
            class="flex items-center border border-gray-200 items-stretch overflow-hidden rounded h-8 m-1">
          <input  v-model="filtro.select_values[index]" type="text" placeholder="Valor" class="input-f w-32 h-8 border-0">
          <span class="button text-white rounded-none flex items-center" @click="remove_select_value(index)"><i v-html='xIcon'></i></span>
        </div>

      </div>
  </div>

  <div v-if="filtro.tipo == 'ccaa'">

    <div class="explain border rounded p-3 my-4 bg-blue-100 text-sm">
     Este filtro permite clasificar los tests por <b>Comunidades Autónomas de España.</b>
    </div>

  </div>


  <div v-if="filtro.tipo == 'provincias'">

    <div class="explain border rounded p-3 my-4 bg-blue-100 text-sm">
      Este filtro permite clasificar los tests por <b>Comunidades y Provincias españolas.</b>
    </div>

  </div>

  <div v-if="filtro.tipo == 'poblaciones'">

    <div class="explain border rounded p-3 my-4 bg-blue-100 text-sm">
      Este filtro permite clasificar los tests por <b>Comunidades, Provincias y Poblaciones españolas.</b>
    </div>

  </div>

  <div class="block mt-5" v-if="validate() == true">
    <button type="button" class="button" @click="save_filtro">Envíar</button>
  </div>

</div>

</template>

<style lang="scss">

</style>